"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.MarkAndLabel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var RC = _interopRequireWildcard(require("./RadioCheckboxParts"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Mark = (0, _styledComponents["default"])(RC.Mark).withConfig({
  displayName: "RadioButtonParts__Mark",
  componentId: "sc-s78k2q-0"
})(["border-radius:50%;"]);
var Label = (0, _styledComponents["default"])(RC.Label).withConfig({
  displayName: "RadioButtonParts__Label",
  componentId: "sc-s78k2q-1"
})(["", ""], function (props) {
  return props.isUppercase ? (0, _styledComponents.css)(["text-transform:uppercase;"]) : (0, _styledComponents.css)(["color:", ";"], function (props) {
    return props.theme.colors.text;
  });
});
var Wrapper = (0, _styledComponents["default"])(RC.Wrapper).withConfig({
  displayName: "RadioButtonParts__Wrapper",
  componentId: "sc-s78k2q-2"
})(["input:checked ~ ", " ", "{border-color:", ";&::after{position:absolute;display:block;content:\"\";height:calc(100% - 4px);width:calc(100% - 4px);top:2px;left:2px;border-radius:50%;background-color:", ";}}"], Label, Mark, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
});
exports.Wrapper = Wrapper;
var MarkAndLabel = function MarkAndLabel(_ref) {
  var htmlFor = _ref.htmlFor,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: htmlFor
  }, /*#__PURE__*/_react["default"].createElement(Mark, null), children);
};
exports.MarkAndLabel = MarkAndLabel;
MarkAndLabel.propTypes = {
  htmlFor: _propTypes["default"].string,
  children: _propTypes["default"].node
};